import { useContext, useEffect, useState } from "react";
import "./basic-compnay-info.scss";
import { SignupContext } from "../../providers/signupProvider";
import { useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../../hooks/typed-hooks";
import {
  ICompanyRegistrationBasicInfo,
  registerCompanyInfo,
  companyRegistrationSelector,
  Insight,
  IWebScrapData,
  AIGeneratedCompanyInsight,
  updateAIGeneratedCompanyInsight,
  WebScrapDataType,
} from "../../../redux/reducers/company-registration/companyRegistrationSlice";
import { toast } from "react-toastify";
import { post } from "../../../common/services/api-service";
import {
  ICompanyInsightInfo,
  companyInsightSelector,
  updateCompanyInsight,
} from "../../../redux/reducers/company-insight/companyInsightSlice";

// todo: Create Insight class in a common place so it can reuse across the application
// Insight class is already present in profile.tsx file as well

// interface Insight {
//     Question: string;
//     Answer: string;
//     QuestionType: string[];
//   }

const BasicCompanyInfo: React.FC = () => {
  const { setCurrentStep } = useContext(SignupContext);
  const navigate = useNavigate();
  const webScrapingAPIURL = "http://localhost:7001/scrape";
  const geminiInsightAPIURL = "http://localhost:6001/generateInsight";

  //const [companyRegistrationInfo, setCompanyRegistrationInfo] = useState<ICompanyRegistrationBasicInfo>();
  const [companyName, setCompanyName] = useState<string>("");
  const [websiteUrl, setWebsiteUrl] = useState<string>("");
  const [businessInsights, setBusinessInsights] = useState<Insight[]>([]);
  const [companyInsightInfo, setCompanyInsightInfo] =
    useState<ICompanyInsightInfo>({});

  const selectCompnayInfo = useAppSelector(companyRegistrationSelector);
  const dispatch = useAppDispatch();

  useEffect(() => {
    console.log("Company registration information ", selectCompnayInfo);

    setCompanyName(selectCompnayInfo.companyName);
    setWebsiteUrl(selectCompnayInfo.websiteUrl);
  }, [selectCompnayInfo]);

  const selectCompanyInsight = useAppSelector(companyInsightSelector);

  useEffect(() => {
    console.log("Company insight data changed", selectCompanyInsight);

    setCompanyInsightInfo(selectCompanyInsight);
  }, [selectCompanyInsight]);

  const notify = (message: string) => toast(message);

  const AskQuestionWithContextToGemini = async (
    context: string,
    question: string
  ) => {
    // setIsMLProcessing(true);
    // setMlProcessingStatusMessage("Insight generation process initiated");
    let response = await post(geminiInsightAPIURL, {
      context: context,
      question: question,
    });
    console.log("Web scrap response " + response);
    // setIsMLProcessing(false);
    // setMlProcessingStatusMessage("Insight generation completed");
    return response.answers;
  };

  const GoToNextStage = async (stage: string) => {
    if (companyName != "" && websiteUrl != "") {
      dispatch(
        registerCompanyInfo({
          ...selectCompnayInfo,
          companyName: companyName,
          websiteUrl: websiteUrl,
        })
      );

      ScrapWebsiteData(websiteUrl);
      // navigate('/signup-s2');
      // return

      /* let webSiteTextContent: string = await ScrapWebsiteData(websiteUrl);

            let question = "Identify the company name, country, location, contact number, email address, branch information, social media presence details, services they offers, product details, their vision and other important insights from the content";
            let answers = await AskQuestionWithContextToGemini(webSiteTextContent, question);
            console.log(answers)
            dispatch(
                updateCompanyInsight({
                  ...companyInsightInfo,
                  answers: answers,
                })
              );
              
            //let answers = '{"branch_information":"3 outlets, 2 easy pickup counters & Online ordering.","company_name":"Ambrosia","contact_number":"0471 2332211","country":"India","email_address":"info@theambrosia.com","location":"TVM","other_insights":["Wide Variety","Explore our wide range of fresh creak cakes, Cartoon cakes, customized Cakes.","TVM, We are Everywhere","Fast Delivery","Fast checkout & delivery with multiple payment options such as Cash on delivery, UPI, Wallets, Netbanking, Debit/Credit card options.","Get H\\nFast\\nDelivery"],"products":["Cakes","Halwas","Burgers","Pizzas","Vancho","Snicker Cake","Real Milk Chocolate","White Chocolate Cake (400gm)","Butter Cream Cake","Vanilla Blueberry","Blueberry Chocolate","Plum Cake","White Forest","Fresh creak cakes","Cartoon cakes","Customized Cakes","Cookies","Fried Chicken","Value Meals","Black Halwa","Milk Halwa","Big Whopper","Bacon Cheese Burger","Chicken Burger","All Veggies Burger","Bakehouse Special","Barbecue Chicken","Triple Cheese","Indian Hot"],"services":["Online ordering","Fast delivery","Multiple payment options (Cash on delivery, UPI, Wallets, Netbanking, Debit/Credit card options)"],"social_media_presence":{"facebook":"https://www.facebook.com/theambrosiabakehouse","instagram":"https://www.instagram.com/theambrosiabakehouse/?hl=en","linkedin":"https://in.linkedin.com/company/the-ambrosia"},"vision":"25 Years of Baking Culture\\nAmbrosia has been delighting customers and foodies alike with a heritage of baking for over 24 years.","website":"https://theambrosia.com/"}';
            for(let key in answers){

                let insight = answers[key];
                let textInsight = "";
                if(Array.isArray(insight)){
                    for(let item in insight){
                        let insightValue = insight[item];
                        if(typeof(insightValue) == "object"){
                            for(let obj in insightValue){
                                textInsight += `${obj}(${insightValue[obj]}) `;
                            }
                        }else{
                            textInsight += `${insightValue},`;
                        }
                    }            
                    textInsight = insight.join(',')
                }else if(typeof(insight) == "object"){
                    for(let obj in insight){
                        textInsight += `${obj}(${insight[obj]}) `;
                    }
                }else{
                    textInsight = insight;
                }

                if(textInsight.trim() != ""){
                    setBusinessInsights((prevInsights)=>[...prevInsights, {
                        Question: "Generate insight",
                        Answer: textInsight,
                        QuestionType: [key.replace(/_/ig, " ").toUpperCase()]
                    }]);
                }
            }

            dispatch(updateAIGeneratedCompanyInsight({...selectCompnayInfo, aiGeneratedInsight : { Insights : businessInsights} }));*/

      setCurrentStep(stage);
      navigate("/signup-s2");
    } else {
      notify("Both company name and website url's are mandatory.");
    }
  };

  const ScrapWebsiteData = async (webURL: string) => {
    //setIsMLProcessing(true);
    //setMlProcessingStatusMessage("Web Scraping started");

    //SKD
    // Temporarly commeting below insight generation code to reduce gemini service cost and consuption
    /* let response = await post(webScrapingAPIURL, { url: webURL });
    console.log("Web scrap response ");
    console.log(response);
    let links = response.links;
    // todo: code for avoid all links that match webURL
    links = links.filter((link: string[]) => link[1].indexOf(webURL) === -1);
    let linkText = links.map((l: any) => l.join(":")).join(",");
    console.log(linkText);
    // setMlProcessingStatusMessage("Received website contents");
    // setIsMLProcessing(false);

    
    let webSiteTextContent = `${response.content} ${linkText}}`;

    let question =
      "Identify the company name, country, location, contact number, email address, branch information, social media presence details, services they offers, product details, their vision and other important insights from the content";
    let answers = await AskQuestionWithContextToGemini(
      webSiteTextContent,
      question
    );
    console.log(answers);*/

    // Simulated answer - Un comment the above code after testing
    let scrapDataObj = JSON.parse(
      '{"branch_information":"3 outlets and 2 easy pickup counters","company_name":"Ambrosia","contact_number":"+0471 2332211","country":"India","email_address":"info@theambrosia.com","location":"TVM","other_important_insights":["25 Years of Baking Culture","Fresh & Healthy Food","Fast Delivery","Multiple Payment Options","Online Ordering","Easy Pickup Counters","Central Kitchen"],"product_details":["Cakes","Halwas","Burgers","Pizzas","Fried Chicken","Appetizers","Salads","Sandwiches","Pastas","Muffins","Cookies","Indian Sweets"],"services":["Cakes","Halwas","Burgers","Pizzas","Fried Chicken","Value Meals","Personalized Gifts","Delivery"],"social_media_presence":{"facebook":"https://www.facebook.com/theambrosiabakehouse","instagram":"https://www.instagram.com/theambrosiabakehouse/?hl=en","linkedin":"https://in.linkedin.com/company/the-ambrosia"},"vision":"Delight customers and foodies alike with a heritage of baking"}'
    );

    const parseWebscrapData = (scrapDataObj: any) => {
      let webscrapDataList: IWebScrapData<any>[] = [];
      for (let webscrapKey in scrapDataObj) {
        let webscrapValue = scrapDataObj[webscrapKey];
        let textInsight = "";
        if (Array.isArray(webscrapValue)) {
          let webscrapItem: IWebScrapData<string[]> = {
            key: webscrapKey,
            value: [],
            type: WebScrapDataType.Array,
          };
          for (let item in webscrapValue) {
            let insightValue = webscrapValue[item];
            if (typeof insightValue == "object") {
              for (let obj in insightValue) {
                //textInsight += `${obj}(${insightValue[obj]}) `;
                webscrapItem.value.push(`${obj}(${insightValue[obj]})`);
              }
            } else {
              //textInsight += `${insightValue},`;
              webscrapItem.value.push(`${insightValue}`);
            }
          }
          webscrapDataList.push(webscrapItem);
          //textInsight = webscrapValue.join(",");
        } else if (typeof webscrapValue == "object") {
          let webscrapItem: IWebScrapData<string[]> = {
            key: webscrapKey,
            value: [],
            type: WebScrapDataType.Array,
          };
          for (let obj in webscrapValue) {
            //textInsight += `${obj}(${webscrapValue[obj]}) `;
            webscrapItem.value.push(`${obj}(${webscrapValue[obj]})`);
          }
          webscrapDataList.push(webscrapItem);
        } else {
          textInsight = webscrapValue;
          let webscrapItem: IWebScrapData<string[]> = {
            key: webscrapKey,
            value: [webscrapValue],
            type: WebScrapDataType.Array,
          };
          webscrapDataList.push(webscrapItem);
        }
      }
      return webscrapDataList;
    };

   let webscrapParseList : IWebScrapData<any>[] = parseWebscrapData(scrapDataObj);

    dispatch(
      updateCompanyInsight({
        ...companyInsightInfo,
        answers: scrapDataObj,
        webscrapParseList : webscrapParseList,
      })
    );

    //let answers = '{"branch_information":"3 outlets, 2 easy pickup counters & Online ordering.","company_name":"Ambrosia","contact_number":"0471 2332211","country":"India","email_address":"info@theambrosia.com","location":"TVM","other_insights":["Wide Variety","Explore our wide range of fresh creak cakes, Cartoon cakes, customized Cakes.","TVM, We are Everywhere","Fast Delivery","Fast checkout & delivery with multiple payment options such as Cash on delivery, UPI, Wallets, Netbanking, Debit/Credit card options.","Get H\\nFast\\nDelivery"],"products":["Cakes","Halwas","Burgers","Pizzas","Vancho","Snicker Cake","Real Milk Chocolate","White Chocolate Cake (400gm)","Butter Cream Cake","Vanilla Blueberry","Blueberry Chocolate","Plum Cake","White Forest","Fresh creak cakes","Cartoon cakes","Customized Cakes","Cookies","Fried Chicken","Value Meals","Black Halwa","Milk Halwa","Big Whopper","Bacon Cheese Burger","Chicken Burger","All Veggies Burger","Bakehouse Special","Barbecue Chicken","Triple Cheese","Indian Hot"],"services":["Online ordering","Fast delivery","Multiple payment options (Cash on delivery, UPI, Wallets, Netbanking, Debit/Credit card options)"],"social_media_presence":{"facebook":"https://www.facebook.com/theambrosiabakehouse","instagram":"https://www.instagram.com/theambrosiabakehouse/?hl=en","linkedin":"https://in.linkedin.com/company/the-ambrosia"},"vision":"25 Years of Baking Culture\\nAmbrosia has been delighting customers and foodies alike with a heritage of baking for over 24 years.","website":"https://theambrosia.com/"}';
    /*for (let key in answers) {
      let insight = answers[key];
      let textInsight = "";
      if (Array.isArray(insight)) {
        for (let item in insight) {
          let insightValue = insight[item];
          if (typeof insightValue == "object") {
            for (let obj in insightValue) {
              textInsight += `${obj}(${insightValue[obj]}) `;
            }
          } else {
            textInsight += `${insightValue},`;
          }
        }
        textInsight = insight.join(",");
      } else if (typeof insight == "object") {
        for (let obj in insight) {
          textInsight += `${obj}(${insight[obj]}) `;
        }
      } else {
        textInsight = insight;
      }

      if (textInsight.trim() != "") {
        setBusinessInsights((prevInsights) => [
          ...prevInsights,
          {
            Question: "Generate insight",
            Answer: textInsight,
            QuestionType: [key.replace(/_/gi, " ").toUpperCase()],
          },
        ]);
      }
    }*/

    // dispatch(
    //   updateAIGeneratedCompanyInsight({
    //     ...selectCompnayInfo,
    //     aiGeneratedInsight: { Insights: businessInsights },
    //   })
    // );

    //return `${response.content} ${linkText}}`;
  };

  return (
    <div className="basic-company-info-wrapper">
      <div className="company-info-title">Let's confirm your company info</div>
      <div>
        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse
        varius enim in eros.
      </div>

      <div className="company-info-form">
        <span>What is your company name ?</span>
        <input
          type="text"
          placeholder="Company name"
          value={companyName}
          onChange={(e) => setCompanyName(e.target.value)}
        />
      </div>

      <div className="company-info-form">
        <span>Website URL</span>
        <input
          type="text"
          placeholder="Company name"
          value={websiteUrl}
          onChange={(e) => setWebsiteUrl(e.target.value)}
        />
      </div>

      <div className="wizard-footer">
        <div>Step 1/4</div>
        <div className="wizard-footer__buttons">
          <div
            className="wizard-button"
            onClick={() => {
              navigate("/signup");
            }}
          >
            Back
          </div>
          <div
            className="wizard-button primary-button"
            onClick={() => {
              GoToNextStage("COMPANY");
            }}
          >
            Next
          </div>
          {/* COMPANY_MORE */}
        </div>
      </div>
    </div>
  );
};

export default BasicCompanyInfo;
